import { render, staticRenderFns } from "./selectdosages.vue?vue&type=template&id=4b8cab60&scoped=true&"
import script from "./selectdosages.vue?vue&type=script&lang=js&"
export * from "./selectdosages.vue?vue&type=script&lang=js&"
import style0 from "./selectdosages.vue?vue&type=style&index=0&id=4b8cab60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8cab60",
  null
  
)

export default component.exports